<div class="main">
    <app-insights-panel [houseId]="houseId"></app-insights-panel>
</div>
